/* @jsxImportSource @emotion/react */

import { css } from '@emotion/react'

const MAC_COLORS = ['#FF5F57', '#FEBC2E', '#28C840']

const dotCss = css`
  width: 12px;
  height: 12px;
  border-radius: 50%;
`

export function TrafficDots({ color }: { color?: string }) {
  const colors = color ? [color, color, color] : MAC_COLORS
  return (
    <div className="flexbox flexbox-align-center flexbox-gap-6 flexbox-no-shrink">
      {colors.map((dotColor, index) => (
        <span key={index} css={dotCss} style={{ backgroundColor: dotColor }} />
      ))}
    </div>
  )
}
